import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LayoutContentComponent, LayoutNavComponent, LayoutNotFoundComponent, LayoutPageComponent } from '@camelot/ui';

import { AppMenuService } from 'src/app/services/menus.service';

import { MenuMainComponent } from './menu/main/menu-main.component';
import { NotFoundPage } from './not-found/not-found.component';

@NgModule({
  declarations: [NotFoundPage],
  exports: [MenuMainComponent],
  imports: [
    CommonModule,
    LayoutContentComponent,
    LayoutNavComponent,
    LayoutNotFoundComponent,
    LayoutPageComponent,
    MenuMainComponent,
  ],
  providers: [AppMenuService],
})
export class AppBaseModule {}
